module.exports = __webpack_public_path__ + "static/media/icon-play.acf483d2.svg";